export type NdtExitPath = '/dashboard' | '/ndt-selection'

const NDT_EXIT_KEY = 'ndtExitPath'

export function setNdtExitPath(path: NdtExitPath) {
  sessionStorage.setItem(NDT_EXIT_KEY, path)
}

export function getNdtExitPath(): NdtExitPath {
  return sessionStorage.getItem(NDT_EXIT_KEY) === '/dashboard'
    ? '/dashboard'
    : '/ndt-selection'
}

export function ndtFormPath(iconName: string): string | null {
  switch (iconName) {
    case 'ET':
      return '/et-test'
    case 'MPI':
      return '/mt-test'
    case 'VT':
      return '/vt-test'
    case 'PT':
      return '/pt-test'
    case 'LT':
      return '/lt-test'
    case 'UT':
      return '/ut-test'
    case 'RT':
      return '/rt-test'
    case 'Thread':
      return '/thread-test'
    case 'SR':
      return '/service-report'
    default:
      return null
  }
}
